import { PageBlockEditorModelV2, PageSectionEditorModelV2 } from "@supernova-studio/model";
import { z } from "zod";

export const PageBlockEditorModel = PageBlockEditorModelV2;
export type PageBlockEditorModel = z.infer<typeof PageBlockEditorModel>;

export const PageSectionEditorModel = PageSectionEditorModelV2;
export type PageSectionEditorModel = z.infer<typeof PageSectionEditorModel>;
